<template>
  <router-view />
</template>

<script>
import store from '@/store';
import * as types from '@/store/mutationTypes';

export default {
  name: 'CompanyBase',
  beforeRouteEnter(to, from, next) {
    if (to.params.id !== from.params.id) {
      store.commit(`applications/${types.START_LOADING}`);
      store.dispatch('companies/getCompany', { id: to.params.id }).then(() => {
        store.commit(`applications/${types.END_LOADING}`);
        next();
      });
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== from.params.id) {
      store.commit(`applications/${types.START_LOADING}`);
      store.dispatch('companies/getCompany', { id: to.params.id }).then(() => {
        store.commit(`applications/${types.END_LOADING}`);
        next();
      });
    } else {
      next();
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/CompanyBase.vue